module.exports = __webpack_public_path__ + "guia_interpretacion_liderphd_2024.pdf?1cf8059a4c00a7e293be18071fbf32c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/guia_interpretacion_liderphd_2024.pdf
// module id = 1181
// module chunks = 2